import React from "react";
import classes from "./Backdrop.module.css";

const backdrop = (props) =>
    <div className={classes.Backdrop}></div>

export default backdrop;
